import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/carte',
    name: 'map',
    component: () => import(/* webpackChunkName: "about" */ '../views/Map.vue'),
    children: [
      {
        path: 'objet/:uid',
        name: 'mapObjet'
      },
      {
        path: 'lot/:uid',
        name: 'mapLot'
      },
      {
        path: 'lots-lies/:uid',
        name: 'mapLinkedLot'
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
